function enableVisualEditing(options = {}) {
  const controller = new AbortController();
  return import("./renderVisualEditing.js").then(({
    renderVisualEditing
  }) => {
    const {
      signal
    } = controller;
    signal.aborted || renderVisualEditing(signal, options);
  }), () => {
    controller.abort();
  };
}
export {
  enableVisualEditing
};
//# sourceMappingURL=enableVisualEditing.js.map
